import { mapOptimizelyLocaleToIntlLocale } from '@shared/utils/helpers/map-optimizely-locale-to-intl-locale';

import { useLanguagesContentQuery } from '../data/graphql/_generated/gql-generated';
import { isNonNullable } from '../helpers/type-compatible-filter-functions';

export const languagesListFallback = [
  { languageId: 'en', languageName: 'English' },
  { languageId: 'id', languageName: 'Bahasa Indonesia' },
  { languageId: 'es', languageName: 'Español' },
  { languageId: 'vi', languageName: 'Tiếng Việt' },
  { languageId: 'th', languageName: 'ภาษาไทย' },
  { languageId: 'zh-Hant', languageName: '繁體中文' },
  { languageId: 'zh-Hans', languageName: '中文(中国)' },
  { languageId: 'ko', languageName: '한국어' },
  { languageId: 'ja', languageName: '日本語' },
];

export const getAllTranslatableLanguageCodes = async () => {
  const data = await useLanguagesContentQuery.fetcher()();

  const languageIdsAndNames = data?.NextSiteSettingsPage?.items?.[0]?.LanguageIdsAndNames;

  if (languageIdsAndNames && languageIdsAndNames.length) {
    const languageCodes = languageIdsAndNames.map((languageEntry) =>
      languageEntry?.ContentLink?.Expanded?.__typename === 'LanguageIdAndName'
        ? languageEntry?.ContentLink?.Expanded.LanguageId
          ? mapOptimizelyLocaleToIntlLocale(languageEntry?.ContentLink?.Expanded.LanguageId)
          : null
        : null
    );
    const filteredLanguageCodes = languageCodes.filter(isNonNullable);
    return [...new Set(filteredLanguageCodes)];
  } else {
    return languagesListFallback.map((language) => language.languageId);
  }
};
